
export default {
    name: 'CustomFormContainer',
    components: {
        CustomForm: () => import('./CustomForm.vue'),
    },
    props: {
        block_title: { type: String, default: '' },
        form_title: { type: String, default: '' },
        description: { type: String, default: '' },
        backgroundImage: { type: String, default: '' },
        submitButtonText: { type: String, default: 'Отправить' },
        fields: { type: Array, required: true, default: () => [] },
    },
    data() {
        return {
            isPopupVisible: false,
        };
    },
    computed: {
        computedBackgroundImage() {
            return `url(${process.env.API_BASE_URL}${this.backgroundImage})`;
        },
    },
    methods: {
        openPopup() {
            this.isPopupVisible = true;
        },
        closePopup() {
            this.isPopupVisible = false;
        },
    },
};
